import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";
import { Orb } from "./orbs/Orb";
import { BoardScene } from "./BoardScene";

export class BoardBackground extends Phaser.GameObjects.Container {

    private renderTexture: Phaser.GameObjects.RenderTexture;
    private shining: boolean;
    private f: number;
    private glareTiles: Phaser.GameObjects.Sprite [][];
    private cols: number;
    private rows: number;

    constructor(scene: Phaser.Scene) {
         
        super(scene);

        this.cols = GameVars.cols;
        this.rows = GameVars.rows;
        this.shining = false;
        this.f = 0;

        this.renderTexture = new Phaser.GameObjects.RenderTexture(this.scene, -.5 * Orb.SIZE, -.5 * Orb.SIZE, this.cols * Orb.SIZE, this.rows * Orb.SIZE);
        
        for (let c = 0; c < this.cols; c ++) {
            for (let r = 0; r < this.rows; r ++) {
                const tile = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_6", "tile");
                tile.setOrigin(0);
                this.renderTexture.draw(tile, c * Orb.SIZE, r * Orb.SIZE);
            }
        }

        this.add(this.renderTexture);

        this.glareTiles = [];

        for (let c = 0; c < this.cols; c ++) {

            this.glareTiles.push([]);

            for (let r = 0; r < this.rows; r ++) {

                const glareTile = new Phaser.GameObjects.Sprite(this.scene, c * Orb.SIZE, r * Orb.SIZE, "texture_atlas_6", "glare_tile_01");
                BoardScene.currentInstance.add.existing(glareTile);
                glareTile.visible = false;
                glareTile.alpha = .65;
                this.add(glareTile);

                this.glareTiles[c].push(glareTile);
            }
        } 
    }

    public update(): void {
        
        if (this.shining) {

            if (this.f % 2 === 0) {

                for (let c = 0; c < this.cols; c ++) {

                    const r = this.f / 2 - c;
    
                    if (r >= 0 && r < this.rows) {
                        this.glareTiles[c][r].anims.play("glare");

                        if (c === this.cols - 1 && r === this.rows - 1) {
                            this.glareTiles[c][r].on("animationcomplete", this.onShineOver, this);
                        }
                    }
                }
            }
        
            this.f ++;

            if (this.f / 2 === this.rows * 2) {
                this.shining = false;
            }

        } else if (!GameVars.orbsMoving && !GameVars.gameOver) {

            this.f ++;

            if (this.f === 300) {
                this.shine();
            }
        }
    }

    public onFallingOrbsAnimationCompleted(): void {

        if (this.shining) {
            return;
        }

        this.f = 150;
        this.shining = false;
    }

    public onLevelUp(newCol: boolean): void {

        if (!this.shining) {
            this.f = 0;
        }

        this.cols = GameVars.cols;
        this.rows = GameVars.rows;
        
        const tiles: Phaser.GameObjects.Image [] = [];

        if (newCol) {
            this.glareTiles.push([]);
            for (let r = 0; r < this.rows; r++) {
                const tile = new Phaser.GameObjects.Image(this.scene, (this.cols - 1) * Orb.SIZE, r * Orb.SIZE, "texture_atlas_6", "tile");
                tiles.push(tile);

                const glareTile = new Phaser.GameObjects.Sprite(this.scene, (this.cols - 1) * Orb.SIZE, r * Orb.SIZE, "texture_atlas_6", "glare_tile_01");
                BoardScene.currentInstance.add.existing(glareTile);
                glareTile.visible = false;
                glareTile.alpha = .65;
                this.add(glareTile);

                this.glareTiles[this.cols - 1][r] = glareTile;
            }
        } else {

            for (let c = 0; c < this.cols; c++) {
                const tile = new Phaser.GameObjects.Image(this.scene, c * Orb.SIZE, (this.rows - 1) * Orb.SIZE, "texture_atlas_6", "tile");
                tiles.push(tile);

                const glareTile = new Phaser.GameObjects.Sprite(this.scene, c * Orb.SIZE, (this.rows - 1) * Orb.SIZE, "texture_atlas_6", "glare_tile_01");
                BoardScene.currentInstance.add.existing(glareTile);
                glareTile.visible = false;
                glareTile.alpha = .65;
                this.add(glareTile);

                this.glareTiles[c][this.rows - 1] = glareTile;
            }
        }

        for (let i = 0; i < tiles.length; i ++) {

            const tile = tiles [i];
            tile.setScale(0);
            this.add(tile);

            this.scene.tweens.add({
                targets: tile,
                scaleX: 1,
                scaleY: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 350,
                delay: 100 + 25 * i,
                onComplete: function(): void {

                    if (i === tiles.length - 1) {
                        this.onTileAnimationsOver(tiles);
                    }
                    
                    AudioManager.playSound("new_cell_added");
                },
                onCompleteScope: this
            });
        }
    }

    private onTileAnimationsOver(tiles: Phaser.GameObjects.Image []): void {

        for (let i = 0; i < tiles.length; i ++) {
            tiles[i].destroy();
        }

        const cols = GameVars.cols;
        const rows = GameVars.rows;

        this.renderTexture.clear();
        this.renderTexture.setSize(cols * Orb.SIZE, rows * Orb.SIZE);

        for (let c = 0; c < cols; c ++) {
            for (let r = 0; r < rows; r ++) {
                const tile = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_6", "tile");
                tile.setOrigin(0);
                this.renderTexture.draw(tile, c * Orb.SIZE, r * Orb.SIZE);
            }
        }
    }

    private shine(): void {

        this.f = 0;
        this.shining = true;

        for (let c = 0; c < this.cols; c ++) {
            for (let r = 0; r < this.rows; r ++) {
                this.glareTiles[c][r].visible = true;
            }
        }
    }

    private onShineOver(): void {

        for (let c = 0; c < this.cols; c ++) {
            for (let r = 0; r < this.rows; r ++) {
                this.glareTiles[c][r].visible = false;
            }
        }
    }
}
